import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from './firebase';

function fileExtension(file: File): string {
  const fromName = file.name.split('.').pop()?.toLowerCase();
  if (fromName && /^[a-z0-9]+$/.test(fromName)) return fromName;
  const fromType = file.type.split('/').pop()?.toLowerCase();
  if (fromType && /^[a-z0-9]+$/.test(fromType)) return fromType;
  return 'jpg';
}

export function profilePhotoStoragePath(userId: string, ext: string): string {
  return `profilePhotos/${userId}/avatar.${ext}`;
}

export async function uploadProfilePhoto(userId: string, file: File): Promise<string> {
  const path = profilePhotoStoragePath(userId, fileExtension(file));
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type || 'image/jpeg' });
  return getDownloadURL(r);
}
